import { z } from 'zod';

export type CompanyRegionResultType = z.infer<typeof companyRegionLazySchema>;
export type CompanyRegionDetailType = z.infer<typeof companyRegionDetailSchema>;
export type CompanyRegionRelationType = z.infer<typeof companyRegionRelationSchema>;

export const companyRegionRelationSchema = z.object({
  id: z.number(),
  name: z.string(),
  shortName: z.string(),
});

export const companyRegionLazySchema = companyRegionRelationSchema.extend({
  regionType: z.string(),
});

export const companyRegionDetailSchema = companyRegionLazySchema.extend({
  businessInfo: z.object({
    companyId: z.number(),
    companyName: z.string(),
    description: z.array(z.string()),
    pictureUrl: z.string().optional(),
  }),
});
